import extend from 'lodash/extend';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: null,
	loading: false,
	error: null,
};

const { actions, reducer } = createSlice({
	name: 'cookies',
	initialState,
	reducers: {
		getCookies: (state) => extend(state, { loading: true, error: null }),
		getCookiesFailure: (state, { payload }) =>
			extend(state, { loading: false, error: payload }),
		getCookiesSuccess: (state, { payload }) =>
			extend(state, { loading: false, error: null, data: payload }),
	},
});

export const { getCookies, getCookiesSuccess, getCookiesFailure } = actions;

export { default as cookiesSaga } from './sagas';

export default reducer;
